import { MesPipe } from './../mes.pipe';
import { DaoService } from 'src/app/servicos/dao.service';
import { Component, OnInit } from '@angular/core';
declare var Chart:any;
@Component({
  selector: 'app-r-ouvidoria',
  templateUrl: './r-ouvidoria.component.html',
  styleUrls: ['./r-ouvidoria.component.css']
})
export class ROuvidoriaComponent implements OnInit {

  constructor(private dao:DaoService) { }

  ngOnInit() {
    this.carregar();
  }

  quantitativos:any;
  colunas:any;
  linhas:any;
  semestre:any = 'primeiro';
  totalAvaliacoesPesquisa: number = 0;
  ano:any;
  pipe:any = new MesPipe();
  hoje = new Date();
  senha:any;
  

  async carregar(){
    let res = await this.dao.submeterEm({},'','https://diviprev.mg.gov.br/controladores/ouvidoria.php');
    let pesq = await this.dao.submeter({},'obterPesquisas');
    console.table(res);
    console.table(pesq);
    if(res && res.length){
      let menorAno = Math.min(...res.map(it=>parseInt(it.ano)));
      this.ano = menorAno;
      res = res.filter(it=>it.ano==this.ano);
      
      this.processar(res);
      console.log(this.quantitativos);
      this.processarPesquisas(pesq);
    }
  }

  tempo:any;
  mudouSenha(){
    if(this.senha=='wellness'){
      console.log("Montando gráfico")
      this.tempo = setTimeout(()=>{this.desenharGrafico();},2000);
      
    }
  }

  pesquisa:any = {};
  pesquisaProduto:any;
  mediaGeral = null;
  processarPesquisas(pesq){
    let mGeral = 0;
    this.pesquisa = Object.create(null);
    this.mesesAlvo.forEach(m=>{this.pesquisa[m]={'atendimento':'-','site':'-','dependencias':'-'}});
    let lista = pesq.filter(p=>p.dia.split('-')[0]==this.ano);
    console.log("A lista ", lista);
    lista.forEach(i=>{
      i.mes=i.dia.split('-')[1];
      mGeral+= ((parseFloat(i.site)+parseFloat(i.atendimento)+parseFloat(i.dependencias))/3);
    });
    this.mediaGeral = (mGeral/lista.length).toFixed(2);
    console.log("MEDIA GERAL ", this.mediaGeral);
    lista = lista.filter(i=>parseInt(i.mes)>=parseInt(this.mesesAlvo[0]));
    console.log("final lista ", lista);
    this.totalAvaliacoesPesquisa = lista.length;
    let mapa = {};
    lista.forEach(i=>{
      if(mapa[i.mes])mapa[i.mes].push(i);
      if(!mapa[i.mes])mapa[i.mes]=[i];
    });

    Object.keys(mapa).forEach(k=>{
      let dep = 0;
      let sit = 0;
      let ate = 0;

      mapa[k].forEach(item=>{
        dep+=parseInt(item.dependencias);
        sit+=parseInt(item.site);
        ate+=parseInt(item.atendimento);
      });
      console.log("set",mapa[k]);
      console.log(dep,sit,ate);
      this.pesquisa[mapa[k][0]['mes']] = Object.create(null);
      this.pesquisa[mapa[k][0]['mes']].atendimento = parseFloat((ate/ mapa[k].length).toFixed(1));
      this.pesquisa[mapa[k][0]['mes']].site = parseFloat((sit/ mapa[k].length).toFixed(1));
      this.pesquisa[mapa[k][0]['mes']].dependencias = parseFloat((dep/ mapa[k].length).toFixed(1));
    });



    console.log("Pesquisa",this.pesquisa);
    this.pesquisaProduto = {
      'site':[],
      'dependencias':[],
      'atendimento':[]
    }
    Object.values(this.pesquisa).forEach(i=>{
      this.pesquisaProduto['site'].push(i['site']);
      this.pesquisaProduto['atendimento'].push(i['atendimento']);
      this.pesquisaProduto['dependencias'].push(i['dependencias']);
    });
    console.log("pesquisaProduto",this.pesquisaProduto)
    console.log("Lista",lista);
    console.log("mapa", mapa);
  }

  tipo(m){
    if(m.includes('solicitacao'))return 'solicitacao';
    if(m.includes('elogio'))return 'elogio';
    if(m.includes('sugestao'))return 'sugestao';
    if(m.includes('reclamacao'))return 'reclamacao';
    if(m.includes('informacao'))return 'informacao';
    if(m.includes('denuncia'))return 'denuncia';
    return 'informacao';
  }

  mesesAlvo:any;
  gerarAlvo(tipo){
    if(tipo=='maior')this.mesesAlvo = ['07','08','09','10','11','12'];
    if(tipo=='menor')this.mesesAlvo = ['01','02','03','04','05','06'];
  }

  processar(res){
    if(parseInt(res[0].dia.split('/')[1])>6){
      this.gerarAlvo('maior');
      res = res.filter(r=>(r.dia.split('/')[1])>6);
    }else{
      this.gerarAlvo('menor');
      res = res.filter(r=>(r.dia.split('/')[1])<7);
    }
    let conj = {
      'total':{
        'informacao':0,
        'solicitacao':0,
        'elogio':0,
        'sugestao':0,
        'reclamacao':0,
        'denuncia':0
      }
    };
    
    res.forEach(m=>{
      let mes = m.dia.split('/')[1];
      
      if(conj[mes]){
        conj[mes][this.tipo(m.mensagem)]++;
        conj['total'][this.tipo(m.mensagem)]++;
      }else{
        conj[mes] = {
          'informacao':0,
          'solicitacao':0,
          'elogio':0,
          'sugestao':0,
          'reclamacao':0,
          'denuncia':0
        };

        conj[mes][this.tipo(m.mensagem)]++;
        conj['total'][this.tipo(m.mensagem)]++;
      }


    });

    Object.values(conj).forEach(ob=>{
      ob['Total'] = 0;
      Object.values(ob).forEach(v=>{ob['Total']+=v});
    })

    this.quantitativos = conj;
    this.colunas = Object.keys(conj);
    if(this.colunas.includes('07'))this.semestre = 'segundo';
    this.linhas = Object.keys(conj['total']);
    this.colunas = this.dao.ordenar(this.colunas,null);
    
    // this.desenharGrafico();
  }

  desenharGrafico(){
     
  const ctx = document.getElementById('myChart');
  let cols = this.colunas.map(el=>el);
  cols.pop();
  let colsString = cols.map(it=>this.pipe.transform(it));
  let vals = cols.map(it=>this.quantitativos[it]['Total']);
  console.log("Vals ",vals);
  

  new Chart(ctx, {
    type: 'bar',
    data: {
      labels: colsString,
      datasets: [{
        label: 'Número de Atendimentos',
        data: vals,
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        y: {
          beginAtZero: true
        }
      }
    }
  });

  }




}
